import Skeleton from '@mui/material/Skeleton';
import { Stack } from 'shared/mui/Stack/Stack';

import { BoxStyled } from './Dashboard.styled';

export const DashboardSkeleton: React.FC = () => (
  <Stack direction="column" gap="16px">
    <BoxStyled>
      <Skeleton height={544} sx={{ flex: 1 }} variant="rounded" />
      <Skeleton height={544} sx={{ flex: 1 }} variant="rounded" />
      <Skeleton height={544} sx={{ flex: 1 }} variant="rounded" />
      <Skeleton height={544} sx={{ flex: 1 }} variant="rounded" />
    </BoxStyled>
  </Stack>
);
